namespace GeniuzPOS.Inventory {
    export interface IcStockSkuRow {
        Id?: number;
        SkuCode?: string;
        QtyOnhand?: number;
        StockCostValue?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace IcStockSkuRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Inventory.IcStockSku';
        export const deletePermission = '2Inventory:ประมวลผลสต๊อก:Modify';
        export const insertPermission = '2Inventory:ประมวลผลสต๊อก:Modify';
        export const readPermission = '2Inventory:ประมวลผลสต๊อก:View';
        export const updatePermission = '2Inventory:ประมวลผลสต๊อก:Modify';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            QtyOnhand = "QtyOnhand",
            StockCostValue = "StockCostValue",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
